import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NodeType } from '@enums';
import { EpiContentComponent } from '@core/containers';
import { Router, Route } from '@angular/router';
import { MenuItem } from '@model';

@Injectable({
  providedIn: 'root'
})
export class SxNavigationMenuService {
  foundLinkObject: MenuItem;
  // generateId(): string {
  //   let text = '';
  //   const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   for (let i = 0; i < 20; i++) {
  //     text += possible.charAt(Math.floor(Math.random() * possible.length));
  //   }
  //   return text;
  // }

  // addRandomId(nodes: MenuItem[]): void {
  //   if (!nodes) {
  //     return;
  //   }
  //   nodes.forEach((node: MenuItem) => {
  //     node.id = this.generateId();
  //     if (node.children && node.children !== undefined) {
  //       this.addRandomId(node.children);
  //     }
  //   });
  // }

  addContentIdToLink(nodes: MenuItem[]): void {
    if (!nodes) {
      return;
    }
    nodes.forEach((node: MenuItem) => {
      if (node.nodeType && node.nodeType === NodeType.Epi) {
        node.linkUrl = this.generateLink(node.linkUrl, node.epiPageRoute);
        if (node.children && node.children !== undefined) {
          this.addContentIdToLink(node.children);
        }
      }

      if (node.children !== undefined) {
        this.addContentIdToLink(node.children);
      }
    });
  }

  generateLink(link: string, epiPageRoute: string): string {
    if (link.includes(':epiPageRoute')) {
      return link.replace(':epiPageRoute', epiPageRoute);
    } else {
      return link;
    }
  }

  tryTranslate(nodes: MenuItem[], translate: TranslateService): void {
    nodes.forEach((node: MenuItem) => {
      let text = translate.instant(node.displayText);
      if (text !== '{' + node.displayText + '}') {
        node.displayText = text;
      }
      if (node.children && node.children !== undefined) {
        this.tryTranslate(node.children, translate);
      }
    });
  }

  getNavigationStructure(nodes: MenuItem[]) {}

  addEpiContentNodesToRouting(router: Router, nodes: MenuItem[]) {
    // Create dynamic route for all nodeType = NodeType.epi
    if (!nodes || nodes.length === 0) {
      return;
    }

    let routerConfig = router.config;
    // Build routes from navigation definition
    this.recursivlyAddDynamicRouting(routerConfig, NodeType.Epi, nodes, EpiContentComponent);

    router.resetConfig(routerConfig);
  }

  recursivlyAddDynamicRouting(routerConfig: Route[], nodeType: NodeType, nodes: MenuItem[], component: any) {
    if (nodes !== null && nodes.length !== 0) {
      nodes.forEach(n => {
        if (n.nodeType === nodeType) {
          this.addDynamicRoute(n, routerConfig, component);
        }

        if (n.children && n.children.length > 0) {
          this.recursivlyAddDynamicRouting(routerConfig, NodeType.Epi, n.children, component);
        }
      });
    }
  }

  addDynamicRoute(node: MenuItem, routerConfig: Route[], component: any) {
    let path = this.cleanPath(node.linkUrl);

    if (!routerConfig.find(p => p.path === path)) {
      routerConfig.push({
        path: path,
        component: component,
        pathMatch: 'full'
      });
    }

    if (node.children && node.children.length > 0) {
      node.children.filter(n => n.nodeType === NodeType.Epi).map(x => this.addDynamicRoute(x, routerConfig, component));
    }
  }

  cleanPath(link: string): string {
    if (link.startsWith('/')) {
      return link.slice(1);
    }
  }

  // setDisabled(nodes: MenuNode[], meteringPoints: { meteringPoints: MeteringPoint[]; loaded: boolean }): void {
  //   nodes.forEach((node: MenuNode) => {
  //     if (node.dataCheck) {
  //       node.disabled = meteringPoints.loaded && meteringPoints.meteringPoints.length === 0;
  //       // || (!this.meteringPoints.loaded || (this.meteringPoints.loaded && this.meteringPoints.meteringPoints.length > 0));
  //     }
  //     if (node.items !== undefined) {
  //       this.setDisabled(node.items, meteringPoints);
  //     }
  //   });
  // }

  initExpanded(nodes: MenuItem[]): void {
    if (!nodes) {
      return;
    }
    nodes.forEach((node: MenuItem) => {
      node.expanded = false;
      if (node.children && node.children !== undefined) {
        this.initExpanded(node.children);
      }
    });
  }

  recursiveCheckId(node: MenuItem, nodeId: string): boolean {
    if (node.id === nodeId) {
      return true;
    } else {
      if (node.children && node.children !== undefined) {
        return node.children.some((nestedNode: MenuItem) => {
          return this.recursiveCheckId(nestedNode, nodeId);
        });
      }
    }
  }

  recursiveCheckLink(nodes: MenuItem[], link: string): void {
    for (let nodeIndex = 0; nodeIndex < nodes.length; nodeIndex++) {
      const node = nodes[nodeIndex];
      for (const key in node) {
        if (node.hasOwnProperty(key)) {
          if (encodeURI(node.linkUrl) === link) {
            this.foundLinkObject = node;
          } else {
            if (node.children && node.children !== undefined) {
              this.recursiveCheckLink(node.children, link);
            }
          }
        }
      }
    }
  }

  getMatchedObjectByUrl(node: MenuItem[], link: string): MenuItem {
    this.recursiveCheckLink(node, link);
    return this.foundLinkObject;
  }
  // overrides key-value pipe's default reordering (by key) by implementing dummy comprarer function
  // https://angular.io/api/common/KeyValuePipe#description
  kvDummyComparerFn() {
    return 0;
  }
}
